import get from 'lodash.get';
import isEqual from 'lodash.isequal';
import isNil from 'lodash.isnil';
import { getMeasuresByGrade } from '../shared/gradeToMeasureUtils';
import { getUrlParams, getUrlString } from '../shared/urlUtils';
import { hasMeasureGradeNoExceptions } from '../shared/tableUtils';
import { MEASURE } from '../../constants/reading/MeasuresConstants';
import { PERIOD } from '../../constants/shared/CommonConstants';
import { TRC_SCORE } from '../../constants/shared/TrcConstants';
import { PARAM } from '../../constants/reading/ApiConstants';
import { ON_GRADE_TEXT } from '../../constants/reading/TroConstants';

const { PS } = TRC_SCORE;
const { BOY, MOY, EOY } = PERIOD;
const { TRO, SPELLING, OL, DO, LEXILE } = MEASURE;
const {
    DISTRICT,
    SCHOOL,
    CLASSE,
    ETERNAL_STUDENT_SID,
    RESULT_PROBE,
    PERIOD: PARAM_PERIOD,
    MEASURE: PARAM_MEASURE,
    ASSESSMENT,
} = PARAM;
const CLICKABLE_TABLE_SCORES = [OL, SPELLING, DO];

export const isMeasureEnabledForGradePeriod = (measureKey, grade, period, gradeToMeasureMapper) => {
    if (measureKey === TRO || measureKey === LEXILE) return true;
    return (
        hasMeasureGradeNoExceptions(measureKey, grade, period) &&
        getMeasuresByGrade(gradeToMeasureMapper, grade).includes(measureKey)
    );
};

const isTroScoreNotClickable = measureResult => {
    const { isDiscontinued, bookResults } = measureResult;
    const onGradeBook = bookResults.find(book => book.relativeLevel === ON_GRADE_TEXT);
    const isCompNotPassed = isNil(onGradeBook.comprehensionResult.score);
    const { isUntranscribable } = onGradeBook.vrrResult;
    return isDiscontinued || (isCompNotPassed && !isUntranscribable);
};

export const isScoreClickable = resultForMeasureYearPeriod => {
    const { score, measure, isComplete, measureResult } = resultForMeasureYearPeriod;

    const isBookTypePS = isEqual(get(score, 'bookType'), PS);
    const isTroNotClickable = measure === TRO && isTroScoreNotClickable(measureResult);
    const isScoreComplete = CLICKABLE_TABLE_SCORES.includes(measure) && !isComplete;

    return resultForMeasureYearPeriod && !(isBookTypePS || isTroNotClickable || isScoreComplete);
};

const PERIOD_CODE_MAPPER = {
    [BOY]: '31',
    [MOY]: '32',
    [EOY]: '33',
};

export const getClasseParam = (classe, burstGroupUid) => (isNil(burstGroupUid) ? classe : null);

export const openNonD8ProbeDetails = (
    url,
    assessment,
    measure,
    period,
    resultId,
    studentId,
    location,
) => {
    const params = getUrlParams(location);
    const { district, school, classe, burstGroupUid } = params;
    const probeDetailsUrl = getUrlString(url, {
        [ETERNAL_STUDENT_SID]: studentId,
        [RESULT_PROBE]: resultId,
        [ASSESSMENT]: assessment,
        [PARAM_MEASURE]: measure,
        [PARAM_PERIOD]: PERIOD_CODE_MAPPER[period],
        [DISTRICT]: district,
        [SCHOOL]: school,
        [CLASSE]: getClasseParam(classe, burstGroupUid),
    });
    window.open(probeDetailsUrl);
};

export const openProbeDetails = (status, resultId, openPanel) =>
    isScoreClickable(status) ? openPanel(resultId) : () => {};

export const getAvailablePeriods = currentPeriod => {
    switch (currentPeriod) {
        case BOY:
            return [BOY];
        case MOY:
            return [BOY, MOY];
        default:
            return [BOY, MOY, EOY];
    }
};
